import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=273e5dfc&scoped=true&"
import script from "./ChangeEmail.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e5dfc",
  null
  
)

export default component.exports